import {useEffect, useState} from "react";
import {Post as TPost} from "../../../types/Post";
import {getPostById} from "../api/getPostById";

export const usePostView = ({ postId }) => {
  const [post, setPost] = useState<TPost>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetch = async () => {
    try {
      setIsLoading(true);
      const tempPost = await getPostById(postId);
      setPost(tempPost);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (postId) {
      fetch();
    }
  }, [postId])

  return { post, isLoading };
}